import * as React from "react";
const SvgLinkExternal = () => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.278 2.25c0-.31.252-.562.563-.562h4.909c.31 0 .563.251.563.562v4.91a.562.562 0 1 1-1.125 0V3.607l-5.79 5.79a.563.563 0 0 1-.796-.796l5.79-5.79h-3.551a.563.563 0 0 1-.563-.562m-8.59 3.955c0-1.14.923-2.063 2.062-2.063h3.41a.563.563 0 0 1 0 1.125H3.75a.94.94 0 0 0-.937.938v8.045c0 .518.42.938.937.938h8.046c.517 0 .937-.42.937-.938v-3.41a.562.562 0 1 1 1.125 0v3.41c0 1.14-.924 2.063-2.062 2.063H3.75a2.06 2.06 0 0 1-2.062-2.063z",
    clipRule: "evenodd"
  }
));
export default SvgLinkExternal;
